<template>
    <main>
        <vue-headful title="ABL Groupe | Profilés spéciaux" />
        <div class="container">
            <h2>Profilés spéciaux / Special profiles</h2>
            <section class="box--container">
                <SubProductBox v-for="(subproduct, index) in require('../../data/subproducts').default" :product="subproduct"
                            :key="index"/>
            </section>
        </div>
    </main>
</template>

<script>
    import SubProductBox from "../../components/SubProductBox"

    export default {
        name: "SpecialProfiles",
        components: {
            SubProductBox
        }
    }
</script>

<style scoped>

</style>